import RegisteredIcon from './component'

export default RegisteredIcon
